import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CreateLabelRequest, Label, UpdateLabelRequest } from '@core/models/labels.model';
import { CreateTagRequest, Tag, UpdateTagRequest } from '@core/models/tags.model';

export const TagsLabelsActions = createActionGroup({
  source: 'TagsLabels',
  events: {
    // Tags list
    'Load Tags': props<{ dataSpaceId?: number }>(),
    'Load Tags Success': props<{ tags: Tag[] }>(),
    'Load Tags Failure': props<{ error: string }>(),

    // Create tag
    'Create Tag': props<{ data: CreateTagRequest }>(),
    'Create Tag Success': props<{ tag: Tag }>(),
    'Create Tag Failure': props<{ error: string }>(),

    // Update tag
    'Update Tag': props<{ id: string; data: UpdateTagRequest }>(),
    'Update Tag Success': props<{ tag: Tag }>(),
    'Update Tag Failure': props<{ error: string }>(),

    // Delete tag
    'Delete Tag': props<{ id: string }>(),
    'Delete Tag Success': props<{ id: string }>(),
    'Delete Tag Failure': props<{ error: string }>(),

    // Labels list
    'Load Labels': props<{ entityTypeFilter?: string; dataSpaceId?: number }>(),
    'Load Labels Success': props<{ labels: Label[] }>(),
    'Load Labels Failure': props<{ error: string }>(),

    // Create label
    'Create Label': props<{ data: CreateLabelRequest }>(),
    'Create Label Success': props<{ label: Label }>(),
    'Create Label Failure': props<{ error: string }>(),

    // Update label
    'Update Label': props<{ id: string; data: UpdateLabelRequest }>(),
    'Update Label Success': props<{ label: Label }>(),
    'Update Label Failure': props<{ error: string }>(),

    // Delete label
    'Delete Label': props<{ id: string }>(),
    'Delete Label Success': props<{ id: string }>(),
    'Delete Label Failure': props<{ error: string }>(),

    // Reset form state
    'Reset Form State': emptyProps()
  }
});
